<template>
  <div class="table">
    <div class="table__header">
      <div
        class="table__col"
        v-for="column in columns"
        :key="column.key"
        :style="column.style"
      >
        <p>{{ column.title }}</p>
      </div>
    </div>
    <Row
      :columns="columns"
      :data="item"
      :index="index"
      v-for="(item, index) in data"
      :key="item.id"
      @change="handleRow"
    >
      <template
        v-for="column in columns"
        :key="column.key"
        v-slot:[column.dataIndex]
      >
        <slot :name="column.dataIndex" :item="item"></slot>
      </template>
      <template v-slot:popover>
        <slot name="popover" :item="item"></slot>
      </template>
    </Row>
  </div>
</template>

<script>
import Row from "./Row";

export default {
  components: { Row },
  props: {
    columns: Array,
    data: Array,
  },
  setup(_, { emit }) {
    const handleRow = (value) => {
      emit("change", value);
    };

    return { handleRow };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}
.table {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  text-align: left;
  overflow: auto;
  border-top: 1px solid rgb(214, 214, 214);
  align-content: start;
}
.table__header {
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  font-weight: 600;
  background-color: #fff;
  z-index: 2;
  border-bottom: 1px solid rgb(214, 214, 214);
}
.table__col {
  width: 150px;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 10px;
  overflow: hidden;
}
.table__popover {
  position: absolute;
  display: none;
  background-color: #fff;
  border: 1px solid blue;
  padding: 5px;
  z-index: 10;
}
.table__popover.--top {
  bottom: 100%;
}
.table__popover.--bottom {
  top: 100%;
}
.open_popover:hover ~ .table__popover {
  display: block;
}
.table__popover:hover {
  display: block;
}
</style>
